<a *ngIf="data" href="{{link.href}}" [ngStyle]="styles" target="{{link.target || '_self'}}">
    <div class="countdown {{position}}" role="region">
        <h2 id="countdown-title" class="countdown-title" [innerHTML]="title"></h2>
        <div class="clock-data" *ngFor="let format of formatArray" aria-hidden="true">
            <div ng-class="{'three-digit': dateData[format].values.length === 3, 'four-digit': dateData[format].values.length === 4}"
                class="clock-value"
                [ngStyle]="clockStyles">
                <span *ngFor="let value of dateData[format].values; trackBy:tracker">{{value}}</span>
            </div>
            <div class="clock-label">
                {{dateData[format].label}}
            </div>
        </div>
        <div class="hide"
            id="aria-clock"
            role="alert"
            aria-live="polite"
            aria-labelledby="countdown-title">
            {{ariaClock}}
        </div>
    </div>
</a>